import Vue from 'vue';
import Vuex from 'vuex';
import errorLog from './errorLog'
import infoLog from './infoLog'
import wechat from './wechat'
Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        wechat,
        errorLog,
        infoLog
    }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js